import { Text, UI, HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../components/TableContent';

import { SecondCopyListItemProps } from '.';

export const SecondCopyListItemMobile: React.FC<SecondCopyListItemProps> = ({
  id,
  selected,
  onCheck,
}) => {
  return (
    <TableContent
      direction="column"
      space={Spacing['stack.xxxs']}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}
      w="full">
      <HStack justifyContent="space-between" space={Spacing['inline.nano']} w="full">
        <Text variant="semibold">Informações da cobrança</Text>
        <UI.Checkbox
          testId={`second-copy-checkbox-${id}`}
          onChange={onCheck}
          options={[{ label: '', value: id }]}
          selectedValues={selected ? [id] : []}
          optionPadding={{ bottom: 0, right: 0 }}
        />
      </HStack>
      <HStack justifyContent="space-between" space={Spacing['inline.nano']} w="full">
        <Text>Nº Cobrança</Text>
        <Text>X</Text>
      </HStack>
      <HStack justifyContent="space-between" space={Spacing['inline.nano']} w="full">
        <Text>Parcela</Text>
        <Text>X</Text>
      </HStack>
      <HStack justifyContent="space-between" space={Spacing['inline.nano']} w="full">
        <Text>Competência</Text>
        <Text>X</Text>
      </HStack>
      <HStack justifyContent="space-between" space={Spacing['inline.nano']} w="full">
        <Text>Data de emissão</Text>
        <Text>X</Text>
      </HStack>
      <HStack justifyContent="space-between" space={Spacing['inline.nano']} w="full">
        <Text>Data vencimento</Text>
        <Text>X</Text>
      </HStack>
      <HStack justifyContent="space-between" space={Spacing['inline.nano']} w="full">
        <Text>Tipo de vencimento</Text>
        <Text>X</Text>
      </HStack>
      <HStack justifyContent="space-between" space={Spacing['inline.nano']} w="full">
        <Text>Situação</Text>
        <Text>X</Text>
      </HStack>
      <HStack justifyContent="space-between" space={Spacing['inline.nano']} w="full">
        <Text>R$ 1500</Text>
        <Text>X</Text>
      </HStack>
    </TableContent>
  );
};
